export default "__VITE_ASSET__Bx3av84a__"